import React from 'react';
import './Divider.css';

const Divider = ({ 
  variant = 'default',
  spacing = 'medium',
  className = '',
  ...props 
}) => {
  const baseClasses = 'divider';
  const variantClasses = `divider-${variant}`;
  const spacingClasses = `divider-spacing-${spacing}`;
  
  const classes = [baseClasses, variantClasses, spacingClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...props} />
  );
};

export default Divider;



